import React, { useRef, useState } from 'react';
import { Button, Header, Input } from '../../components';
import Alert from '../../components/Alert';
import { IoCalendarOutline } from "react-icons/io5";
import { BsCalendar4Range } from "react-icons/bs";
import Loading from '../../components/Loading';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa';
import Icon from '../../data/icon.png';

const Situation = () => {
  const [errors, setErrors] = useState(null);
  const [showJournal, setShowJournal] = useState(false);
  const [showBilan, setShowBilan] = useState(false);
  const [initial, setInitial] = useState(true);
  const [journal, setJournal] = useState([]);
  const [loadingJournal, setLoadingJournal] = useState(false);
  const [loadingBilan, setLoadingBilan] = useState(false);
  const journalRef = useRef();
  const bilanRef = useRef();
  const jounalPrintRef = useRef();
  const bilanPrintRef = useRef();
  const [total, setTotal] = useState({
    somme: 0,
    nombre: 0,
  });

  const [bilan, setBilan] = useState({
    depenses: [],
    totalEntree: 0,
    totalDepense:0,
    totalSortie:0,
  });


  const [req, setReq] = useState({
    DateDebut: '',
    DateFin: '',
  });
  const { setToken } = useStateContext();
  const navigate = useNavigate();

  const getJournal = () => {
    setInitial(true);

    setShowBilan(false);
    setLoadingBilan(false);
    setInitial(false);
    setShowJournal(true);
    setLoadingJournal(true);
    setErrors(null);
    axiosClient.get('/journals?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin)
      .then((response) => {
        setJournal(response.data.journal);
        setLoadingJournal(false);
        setShowJournal(true);
        setTotal({ ...total, somme: response.data.total, nombre: response.data.nombre })
      }).catch(err => {
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoadingJournal(false);
            toast.error('Merci de verifier les informations a saisies!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })

  }

  const getBilan = () => {
    setInitial(true);
    setLoadingJournal(false);
    setShowJournal(false);
    setInitial(false);
    setShowBilan(true);
    setLoadingBilan(true);
    setErrors(null);
    axiosClient.get('/bilan?DateDebut=' + req.DateDebut + '&DateFin=' + req.DateFin)
      .then((response) => {
        setBilan({ ...bilan, depenses: response.data.depenses,totalDepense:parseFloat(response.data.depenses.reduce((n, {montant}) => n + parseFloat(montant), 0)), totalEntree: response.data.totalEntree,totalSortie:response.data.totalSortie});
        setLoadingBilan(false);
      }).catch(err => {
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoadingBilan(false);
            toast.error('Merci de verifier les informations a saisies!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })

  }


  return (
    <>
      <Header title="Situations" />
      {errors &&
        Object.keys(errors).map(key => (
          <Alert key={key} message={errors[key][0]} />
        ))
      }
      <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>
        <Input label="Date debut" type="date" value={req.DateDebut} onChange={ev => setReq({ ...req, DateDebut: ev.target.value })} required="required" />
        <Input label="Date fin" type="date" value={req.DateFin} onChange={ev => setReq({ ...req, DateFin: ev.target.value })} required="required" />

        <div className='mt-8'>
          <Button onClick={() => getJournal()} color="bg-yellow-500" icon={<IoCalendarOutline />} size="20" text="Journal" textColor="text-white" />
        </div>
        <div className='mt-8'>
          <Button onClick={() => getBilan()} color="bg-green-500" icon={<BsCalendar4Range />} size="20" text="Bilan" textColor="text-white" />
        </div>
      </div>
      <div className='flex flex-col gap-4 mt-4'>
        {initial ? <></> :

          <>
            {showJournal ?
              <>
                {loadingJournal ? <Loading /> : <>
                  <div className="flex justify-end items-end gap-2">
                    <ReactToPrint
                      trigger={() => {
                        return <Button icon={<FaPrint />} color="ml-1 bg-blue-500" textColor="text-white" text="Imprimer" />
                      }}
                      content={() => jounalPrintRef.current}
                      documentTitle='Journal'
                      pageStyle='journal'
                    />
                    <DownloadTableExcel
                      filename="Journal"
                      sheet="journal"
                      currentTableRef={journalRef.current}
                    >
                      <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

                    </DownloadTableExcel>
                  </div>
                  <div className='mt-3 w-full overflow-x-auto'>
                    <div className='p-2' ref={jounalPrintRef}>
                      <table className='table-auto'>
                        <thead>
                          <tr>
                            <td>
                              <div className="flex justify-between gap-3">
                                <div className="flex flex-col gap-3">
                                  <h1>Repulic Islamic de Mauritanie</h1>
                                  <h1>Ecoles privées Ahmed Deina Fall</h1>
                                  <h2>Tel: 27111108 41322928</h2>
                                </div>
                                <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
                                <div className="flex flex-col text-right gap-3">
                                  <h1>الجمهوريــة الإسلاميــة الموريتـانيــة</h1>
                                  <h1>مدارس أحمد دينا افال الحرة</h1>
                                  <h2> 27111108 41322928 : الهاتف</h2>
                                </div>
                              </div>
                              <div className="flex justify-center items-center">
                                <h1>Journal Caisse du: {req.DateDebut} au: {req.DateFin}</h1>
                              </div>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <div className='my-2'>
                            <h2 className='text-lg font-bold'>Total= {total.somme} MRU ({total.nombre})</h2>
                          </div>
                          <table ref={journalRef} className='table-auto'>
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Elève</th>
                                <th>Classe</th>
                                <th>Montant</th>
                                <th>M.Paiement</th>
                              </tr>
                            </thead>
                            <tbody>
                              {journal && journal.map(o => (
                                <tr key={o.id}>
                                  <td>{o.datePaiement}</td>
                                  <td>{o.inscription.eleve}</td>
                                  <td>{o.inscription.classe.libelle}</td>
                                  <td>{o.montant}</td>
                                  <td>{o.typePaiement}</td>
                                </tr>
                              ))

                              }
                            </tbody>
                          </table>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </>

                }
              </>
              :
              <></>
            }
            {showBilan ?
              <>
                {loadingBilan ? <Loading /> :
                  <>
                    <div className="flex justify-end items-end gap-2">
                      <ReactToPrint
                        trigger={() => {
                          return <Button icon={<FaPrint />} color="ml-1 bg-blue-500" textColor="text-white" text="Imprimer" />
                        }}
                        content={() => bilanPrintRef.current}
                        documentTitle='Bilan'
                        pageStyle='bilan'
                      />

                    </div>
                    <div className="mt-3 w-full overflow-x-auto">
                      <div ref={bilanPrintRef} className="p-3">
                        <table className='table-auto'>
                          <thead>
                            <tr>
                              <td>
                                <div className="flex justify-between gap-3">
                                <div className="flex flex-col gap-3">
                                  <h1>Repulic Islamic de Mauritanie</h1>
                                  <h1>Ecoles privées Ahmed Deina Fall</h1>
                                  <h2>Tel: 27111108 41322928</h2>
                                </div>
                                <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
                                <div className="flex flex-col text-right gap-3">
                                  <h1>الجمهوريــة الإسلاميــة الموريتـانيــة</h1>
                                  <h1>مدارس أحمد دينا افال الحرة</h1>
                                  <h2> 27111108 41322928 : الهاتف</h2>
                                </div>
                                </div>
                                <div className="flex justify-center items-center">
                                  <h1>Bilan Caisse du: {req.DateDebut} au: {req.DateFin}</h1>
                                </div>
                              </td>
                            </tr>
                          </thead>
                          <tbody>

                            <table ref={bilanRef} className='table-auto'>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Beneficiaire</th>
                                  <th>Categorie</th>
                                  <th>Montant</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bilan.depenses && bilan.depenses.map(o=>(
                                  <tr>
                                    <td>{o.dateDepense}</td>
                                    <td>{o.beneficiaire}</td>
                                    <td>{o.categorie}</td>
                                    <td>{o.montant}</td>
                                  </tr>
                                ))

                                }
                                <tr>
                                  <td colSpan="3">Total dépenses</td>
                                  <td>{bilan.totalDepense}</td>
                                </tr>
                                <tr>
                                  <td colSpan="3">Total entrées</td>
                                  <td>{bilan.totalEntree}</td>
                                </tr>
                                <tr>
                                  <td colSpan="3">Total sorties</td>
                                  <td>{bilan.totalSortie}</td>
                                </tr>
                                <tr>
                                  <td colSpan="3">Caisse</td>
                                  <td>{bilan.totalEntree-bilan.totalDepense-bilan.totalSortie}</td>
                                </tr>
                              </tbody>
                            </table>
                          </tbody>
                        </table>
                      </div>

                    </div>
                  </>
                }

              </>
              :
              <></>

            }

          </>

        }


      </div>
    </>
  )
}

export default Situation